namespace GeniuzPOS.Points {
    export interface PrPointRedeemItemRow {
        Id?: number;
        PluCode?: string;
        PluName?: string;
        NoOfPoint?: number;
        StartDate?: string;
        EndDate?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace PrPointRedeemItemRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PluCode';
        export const localTextPrefix = 'Points.PrPointRedeemItem';
        export const lookupKey = 'Points.PrPointRedeemItem';

        export function getLookup(): Q.Lookup<PrPointRedeemItemRow> {
            return Q.getLookup<PrPointRedeemItemRow>('Points.PrPointRedeemItem');
        }
        export const deletePermission = '3Member:Points:แต้มแลกสินค้า:Delete';
        export const insertPermission = '3Member:Points:แต้มแลกสินค้า:Modify';
        export const readPermission = '3Member:Points:แต้มแลกสินค้า:View';
        export const updatePermission = '3Member:Points:แต้มแลกสินค้า:Modify';

        export declare const enum Fields {
            Id = "Id",
            PluCode = "PluCode",
            PluName = "PluName",
            NoOfPoint = "NoOfPoint",
            StartDate = "StartDate",
            EndDate = "EndDate",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
